import { useResourceContext } from 'react-admin';
import { rbac } from '@utils/rbac';

export const useRbacList = (): boolean => {
  const resource = useResourceContext();

  return rbac.canShowList(resource);
};
